<template>
    <div class="location-selector" ref="locationSelector">
        <div class="dropdown br16">
            <button
                class="btn dropdown-toggle mx-auto"
                type="button"
                id="locationSelectButton"
                v-on:click="toggleLocationSelector"
            >
                <i class="bx bx-current-location text-brand-500"></i>
                <span class="text-neutral-800 body-small ps-2" v-cloak>
                    {{
                        availableLocations[currentLocation] ||
                        "Selecionar Localização"
                    }}
                </span>
            </button>

            <div
                class="dropdown-menu rounded-4 p20 border-neutral-300 common-box-shadow"
                :class="{
                    'dropdown-inline': display == 'inline',
                }"
                aria-labelledby="locationSelectButton"
                v-bind:class="{ show: isLocationSeletionDropdownOpened }"
            >
                <div
                    class="font-weight-bold body-medium mb-3 d-none d-md-block"
                >
                    Alterar Localização
                </div>

                <button
                    v-if="geolocationSupported"
                    :class="{ 'w-100': display == 'inline' }"
                    class="btn border-neutral-300 border-neutral-400-hover body-medium text-neutral-700 w-100 mb8 p20 text-start lh18"
                    @click="handleGeolocation"
                    :disabled="loadingGeolocation"
                >
                    <span :class="{ 'd-none': loadingGeolocation }"
                        ><i class="bx bx-current-location text-neutral-900"></i>
                        Usar minha localização</span
                    >
                    <span
                        :class="{ 'd-none': !loadingGeolocation }"
                        class="w-100 d-block text-center"
                    >
                        <i class="bx bx-spin bx-loader text-neutral-900"></i>
                    </span>
                </button>

                <div
                    v-if="showError"
                    class="alert text-sm py-2 px-3 mb-2 rounded small text-brand-500 border-brand-200 bg-brand-100"
                >
                    <i class="bx bx-meh"></i> {{ errorMessage }}
                </div>

                <button
                    v-for="(label, key) in availableLocations"
                    :key="key"
                    :class="{ 'w-100': display == 'inline' }"
                    class="btn border-neutral-300 border-neutral-400-hover body-medium text-neutral-700 w-100 mb8 p20 text-start lh18"
                    @click="redirectTo(key)"
                >
                    <i class="bx bx-map text-neutral-900"></i> {{ label }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
export default {
    name: "LocationSelector",
    props: {
        display: {
            validator: (value) => ["absolute", "inline"].includes(value),
            type: String,
            default: "absolute",
        },
    },
    data() {
        return {
            currentLocation: window.locations?.current || null,
            availableLocations: window.locations?.all || {},
            isLocationSeletionDropdownOpened: false,
            geolocationSupported: !!navigator.geolocation,
            loadingGeolocation: false,
            showError: false,
            errorMessage: "",
        }
    },
    mounted() {
        document.addEventListener("click", (ev) => this.closeDropdown(ev))
    },
    unmounted() {
        document.removeEventListener("click", (ev) => this.closeDropdown(ev))
    },
    methods: {
        toggleLocationSelector() {
            this.isLocationSeletionDropdownOpened =
                !this.isLocationSeletionDropdownOpened
        },
        closeDropdown(event) {
            const dropdown = this.$refs.locationSelector
            if (dropdown && !dropdown.contains(event.target)) {
                this.isLocationSeletionDropdownOpened = false
            }
        },
        handleError(error) {
            this.loadingGeolocation = false
            this.geolocationSupported = false
            console.error("Erro ao obter localização:", error)
            this.showError = true
            this.errorMessage =
                "Não foi possível acessar sua localização. Você pode escolher manualmente abaixo."
        },
        handleGeolocation() {
            this.showError = false
            this.errorMessage = ""
            this.loadingGeolocation = true

            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords

                    try {
                        const response = await axios.get(
                            window.routes.getLocation
                                .replace("__lat", latitude)
                                .replace("__lng", longitude)
                        )

                        if (!response.data?.uf) {
                            throw new Error("Localização inválida")
                        }

                        this.redirectTo(response.data.uf)
                    } catch (e) {
                        this.handleError(e)
                    } finally {
                        this.loadingGeolocation = false
                    }
                },
                this.handleError,
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0,
                }
            )
        },
        redirectTo(uf) {
            const current = window.location.href
            const destination =
                window.routes.setLocation.replace(
                    `/${this.currentLocation}`,
                    `/${uf}`
                ) + `?r=${encodeURI(encodeURIComponent(current))}`

            document.location.href = destination
        },
    },
}
</script>

<style scoped>
.dropdown-inline.show {
    position: relative;
    box-shadow: none;
    border: 0;
    width: 100%;
    max-width: 100%;
}
</style>
